import { c as _c } from "react/compiler-runtime";
import { ManageFieldsInterface } from 'modules/contacts/components/update-fields-modal/types/manage-fields-interface';
import { transformFieldValuesToFields } from 'modules/payment/subscriptions/utils/transform-field-values-to-fields';
import { SETTINGS_SUBSCRIPTIONS_API } from 'modules/profile/manage-subscriptions/api/update-customer-fields-api';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
interface UpdateSubscriptionFieldsProps {
  subscriptionId: number;
}
export const useUpdateSubscriptionFields = t0 => {
  const $ = _c(7);
  const {
    subscriptionId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.patch
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t1);
  let t2;
  if ($[1] !== fetcher || $[2] !== subscriptionId) {
    t2 = data => fetcher(`${SETTINGS_SUBSCRIPTIONS_API}/customer/field-values/update`, transformFieldValuesToFields(data, subscriptionId));
    $[1] = fetcher;
    $[2] = subscriptionId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const updateSubscriptionFields = t2;
  let t3;
  if ($[4] !== isFetching || $[5] !== updateSubscriptionFields) {
    t3 = {
      updateSubscriptionFields,
      isFetchUpdate: isFetching
    };
    $[4] = isFetching;
    $[5] = updateSubscriptionFields;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};